import { css } from "lit";
const styles = css`
  :host {
    flex: 1;
    align-self: flex-start;
    flex-direction: column;
    position: relative;
  }

  .horizontal ::slotted(*) {
    padding: 0 (0.8 * var(--dsf-base-size));
  }

  .vertical {
    &.medium .content::before {
      height: calc(100% - (2.4 * var(--dsf-base-size))); // 32 / 2 + 4
    }

    &.small .content::before {
      height: calc(100% - (1.6 * var(--dsf-base-size))); // 24 / 2 + 4
    }

    &.minimal .content::before {
      height: calc(100% - ((0.4 + 0.6) * var(--dsf-base-size))); // 12 / 2 + 4 BUT ITS NOT
    }

    .content {
      position: relative;
      &:not(.last)::before {
        content: '';
        display: block;
        position: absolute;
        width: calc(0.1 * var(--dsf-base-size));
        background: rgba(var(--dsf-color-neutral-200), 1);
        background: rgba(var(--dsf-color-neutral-200), 1);
      }
    }
  }

  .horizontal {
    /* Default: gray on both sides */
    &::before,
    &::after {
      background: rgba(var(--dsf-color-neutral-200), 1);
    }

    /* Completed: orange on both sides */
    &.completed {
      &::before,
      &::after {
        background: rgba(var(--dsf-color-primary-300), 1);
      }
    }

    /* Active: left orange gray right */
    &.active {
      &::before {
        background: rgba(var(--dsf-color-primary-300), 1);
      }

      &::after {
        background: rgba(var(--dsf-color-neutral-200), 1);
      }
    }
  }

  dsf-step-number[dsf_size='medium']::before {
    right: calc(50% + (2.8 * var(--dsf-base-size)));
    left: 0;
  }

  dsf-step-number[dsf_size='medium']::after {
    left: calc(50% + (2.8 * var(--dsf-base-size)));
    right: 0;
  }

  dsf-step-number[dsf_size='small']::before {
    right: calc(50% + (2.4 * var(--dsf-base-size)));
    left: 0;
  }

  dsf-step-number[dsf_size='small']::after {
    left: calc(50% + (2.4 * var(--dsf-base-size)));
    right: 0;
  }

  dsf-step-number[dsf_size='minimal']::before {
    right: calc(50% + (1.2 * var(--dsf-base-size)));
    left: 0;
  }

  dsf-step-number[dsf_size='minimal']::after {
    left: calc(50% + (1.2 * var(--dsf-base-size)));
    right: 0;
  }

  dsf-step-number:not(.first)::before,
  dsf-step-number:not(.last)::after {
    content: '';
    position: absolute;
    display: block;
    height: calc(0.1 * var(--dsf-base-size));
    top: 50%;
  }

  dsf-step-number:not(.last)::after {
    content: '';
    position: absolute;
    display: block;
    height: calc(0.1 * var(--dsf-base-size));
    top: 50%;
  }

  /* Styles for vertical connector */
  .medium.vertical .content::before {
    left: calc(-2.45 * var(--dsf-base-size));
    top: calc((3.2 + 0.4) * var(--dsf-base-size)); /* Height of step + space to arrow */
  }

  .small.vertical .content::before {
    left: calc(-2.05 * var(--dsf-base-size));
    top: calc((2.4 + 0.4) * var(--dsf-base-size)); /* Height of step + space to arrow */
  }

  .minimal.vertical .content::before {
    left: calc(-1.45 * var(--dsf-base-size));
    top: calc(
      (1.2 + 0.4 + 0.2) * var(--dsf-base-size)
    ); /* Height of step + space to arrow + margin-top for minimal */
  }
`;
export {
  styles
};
